import '../css/index.scss'
import {handleEvents} from "./events";
// This CSS reached every page through the ads code that the common bundle used to import. The ads code is gone from
// the bundle; the CSS stays in common.css so no page loses styles it had.
import "../../vendor/virtual_select/css/virtual-select.min.css";
import "../css/virtual-select-mod.scss";
import {initDefaultSelect2} from "./select2";
import {disableConsoleLogs} from "./utils";
import {initI18Next} from "./i18next";
import {initCreemSubscriptionModal} from "./creem-subscription-modal";
import {initSearchControls} from "./search-control";
import {initFileDeleteModal} from "./file-delete-modal";
import {initInAppBell} from "../../notifications/js/bell";
import {initInAppPopupPreview, initInAppPopups} from "../../notifications/js/popup-trigger";
import {initPublicShell} from "./public-shell";


$(document).ready(function () {
    //disableConsoleLogs()
    initPublicShell()
    window.__commonI18nReady = initI18Next(['common', 'billing'])
    initCreemSubscriptionModal(window.__commonI18nReady)
    initSearchControls()
    handleEvents()
    initDefaultSelect2()
    initFileDeleteModal()
    const bell = initInAppBell(window.__commonI18nReady)
    initInAppPopups(bell?.firstCount, window.__commonI18nReady)
    initInAppPopupPreview(window.__commonI18nReady)

})
